// FFs
export const FEEDBACK_PAGE_FF = 'learning_app_fe_feedback_page';
export const EMAIL_SUBSCRIPTION_FF = 'learning_app_fe_email_subscription';
export const CHAMPIONS_PAGE_FF = 'community-champions-page';

export enum Environment {
  'DEVELOPMENT' = 'development',
  'STAGING' = 'staging',
  'PRODUCTION' = 'production',
  'LOCAL' = 'local',
}

//Hubs type
export enum AlternativeContentHubType {
  CERT_PREP = 'cert-prep',
  ROLE_BASED = 'role-based',
}

export enum AlternativeCollectionType {
  ROLE_BASED = 'role-based',
  CERT_PREP = 'cert-prep',
}

export enum LandingType {
  LIVE_TRAINING = 'live-training',
  CERTIFICATION_DETAIL = 'certification-detail',
}

export enum ContentHubType {
  CERT_PREP = 'prepare-for-a-certification',
  ROLE_BASED = 'grow-your-career',
  LEARNING_PATHS = 'all-learning-paths',
  CERTIFICATIONS = 'certifications',
}

export enum CollectionType {
  CERT_PREP = 'certification-prep',
  ROLE_BASED = 'career',
  TOPIC = 'topic',
}

export enum ResourceType {
  SmLesson = 'lesson',
  SmCourse = 'course',
  LearningPath = 'learningPath',
  Collection = 'collection',
  Certification = 'certification',
  InstructorLedTraining = 'instructorLedTraining',
}
